export function normalizeInternalPath<T extends string | undefined>(path: T): T {
  if (typeof path !== 'string') return undefined as T;
  if (path === '/') return '/' as T;

  const [pathWithoutFragment, fragment] = path.split('#');
  const cleanPath = pathWithoutFragment.toLowerCase().replace(/\/$/, '');

  return fragment ? (`${cleanPath}#${fragment}` as T) : (cleanPath as T);
}
